var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"prev",attrs:{"type":"button","disabled":!_vm.active},on:{"click":_vm.onClick}},[_c('Icon'),_c('span',[_vm._v("Zurück")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }